import { KitchenStatus, KitchenStatuses } from 'src/constants/KitchenStatus';

export function isPreparingKitchenOrder(status?: KitchenStatus): boolean {
    return status === KitchenStatuses.PREPARING;
}
